export default __webpack_public_path__ + "static/media/logo_purple.8269a607.png";